import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as esAPI from '../../lib/api/esapi';
import { takeLatest } from 'redux-saga/effects';
import { remove } from 'lodash';

/**
 * 내가구 견적서 작성 화면에서 사용하는 Data 
 */

/**
 * API 서버에 Request 하는 Action Type
 */
//첫번째 스탭에서 카테고리에 해당하는 브랜드 정보 요청
const [
    REQ_TYPE_POST_ESMY_STEP1,
    REQ_TYPE_POST_ESMY_STEP1_SUCCESS,
    REQ_TYPE_POST_ESMY_STEP1_FAILURE,
] = createRequestActionTypes('esmy/REQ_TYPE_POST_ESMY_STEP1');

//전체 브랜드의 2nd 카테고리 이름 가져오기.
const [
    REQ_TYPE_POST_ESMY_CATE2_NAME,
    REQ_TYPE_POST_ESMY_CATE2_NAME_SUCCESS,
    REQ_TYPE_POST_ESMY_CATE2_NAME_FAILURE,
] = createRequestActionTypes('esmy/REQ_TYPE_POST_ESMY_CATE2_NAME');

//세번째 스탭에서 카테고리에 해당하는 브랜드와 상품 정보 요청
const [
    REQ_TYPE_POST_ESMY_STEP3,
    REQ_TYPE_POST_ESMY_STEP3_SUCCESS,
    REQ_TYPE_POST_ESMY_STEP3_FAILURE,
] = createRequestActionTypes('esmy/REQ_TYPE_POST_ESMY_STEP3');

const [
    REQ_TYPE_POST_ESMY_STEP3_ADD,
    REQ_TYPE_POST_ESMY_STEP3_ADD_SUCCESS,
    REQ_TYPE_POST_ESMY_STEP3_ADD_FAILURE,
] = createRequestActionTypes('esmy/REQ_TYPE_POST_ESMY_STEP3_ADD');

//세번째 스탭에서 팝업에서 브랜드 개수
const [
    REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM,
    REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM_SUCCESS,
    REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM_FAILURE,
] = createRequestActionTypes('esmy/REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM');

// 데이터 초기화
const ES_ESMY_INIT = 'esmy/ES_ESMY_INIT';
// 견적 브랜드 카테고리 데이터 저장.
const ES_ESMY_BRAND_CATE_STEP1 = 'esmy/ES_ESMY_BRAND_CATE_STEP1';
const ES_ESMY_BRAND_CATE_STEP3 = 'esmy/ES_ESMY_BRAND_CATE_STEP3';
// 나의 예산
const ES_ESMY_BUDGET = 'esmy/ES_ESMY_BUDGET';
// 스탭3에서 브랜드 id 저장
const ES_ESMY_SEL_BRAND_STEP3 = 'esmy/ES_ESMY_SEL_BRANd_STEP3';
// 스탭4에서 필터/카테고리 정보 저장
const ES_ESMY_INFO_STEP4 = 'esmy/ES_ESMY_INFO_STEP4'

// 견적 작성 상품 저장 
const ES_ESMY_APPLY_PROD = 'esmy/ES_ESMY_APPLY_PROD';
// 견적 작성 상품 삭제  
const ES_ESMY_APPLY_PROD_DEL = 'esmy/ES_ESMY_APPLY_PROD_DEL';

export const reqEsBrandStep1 = createAction(REQ_TYPE_POST_ESMY_STEP1, (cateItems) => {
    return { cateItems }
});

export const reqEsBrandStep3 = createAction(REQ_TYPE_POST_ESMY_STEP3, (cateItems, offset) => {
    return { cateItems, offset }
});

export const reqEsBrandStep3Add = createAction(REQ_TYPE_POST_ESMY_STEP3_ADD, (cateItems, offset) => {
    return { cateItems, offset }
});

export const reqEsBrandCate2Name= createAction(REQ_TYPE_POST_ESMY_CATE2_NAME);

export const reqEsBrandStep3BrandNum = createAction(REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM, (cateItems) => {
    return { cateItems }
});

// 데이터 초기화
export const setEsMyInit = createAction(ES_ESMY_INIT);
// 견적 브랜드 카테고리 데이터 저장.
export const setEsMyBrandCate1StepAction = createAction(ES_ESMY_BRAND_CATE_STEP1);
export const setEsMyBrandCate3StepAction = createAction(ES_ESMY_BRAND_CATE_STEP3);
// 나의 예산
export const setEsMyBudgetAction = createAction(ES_ESMY_BUDGET);
// 스탭3에서 브랜드 id 저장
export const setEsMySelBrandStep3Action = createAction(ES_ESMY_SEL_BRAND_STEP3);
// 스탭4에서 필터/카테고리 정보 저장
export const setEsMyInfoStep4Action = createAction(ES_ESMY_INFO_STEP4);
// 견적 작성 상품 저장 
export const setEsMyApplyProdAction = createAction(ES_ESMY_APPLY_PROD);
// 견적 작성 상품 삭제  
export const setEsMyApplyProdDelAction = createAction(ES_ESMY_APPLY_PROD_DEL);
/**
 * SAGA API 에서 REST API 호출 
 */
const reqEsBrandStep1Saga = createRequestSaga(REQ_TYPE_POST_ESMY_STEP1, esAPI.getBrandMyEsStep1);
const reqEsBrandCate2NameSaga = createRequestSaga(REQ_TYPE_POST_ESMY_CATE2_NAME, esAPI.getBrandMyEsCate2Name);
const reqEsBrandStep3Saga = createRequestSaga(REQ_TYPE_POST_ESMY_STEP3, esAPI.getBrandMyEsStep3);
const reqEsBrandStep3AddSaga = createRequestSaga(REQ_TYPE_POST_ESMY_STEP3_ADD, esAPI.getBrandMyEsStep3);
const reqEsBrandStep3BrandNumSaga = createRequestSaga(REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM, esAPI.getBrandMyEsStep1);

export function* esMyItemsSaga() {
    yield takeLatest(REQ_TYPE_POST_ESMY_STEP1, reqEsBrandStep1Saga);
    yield takeLatest(REQ_TYPE_POST_ESMY_CATE2_NAME, reqEsBrandCate2NameSaga);
    yield takeLatest(REQ_TYPE_POST_ESMY_STEP3, reqEsBrandStep3Saga);
    yield takeLatest(REQ_TYPE_POST_ESMY_STEP3_ADD, reqEsBrandStep3AddSaga);
    yield takeLatest(REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM, reqEsBrandStep3BrandNumSaga);
}


/**
 * Store에 저장될 값 
 */
const initialState = {
    error: null,
    esMyBrandCate1Step:[], //첫 스탭에서 가지고 있는 카테고리 정보
    esBrandMyStep1: null, //내 가구 견적 첫번째 스탭 브랜드 정보
    esMyBudget: 0, // 나의 예산
    esCate2Name: null, //브랜드의 카테고리 2 이름 정보 저장
    esMyBrandCate3Step:[], //3번째 스탭에서 가지고 있는 카테고리 정보
    esBrandMyStep3: null, //내 가구 견적 세번째 스탭 브랜드 상품 정보
    esSelBrandStep3: [], //내 가구 견적 3번째 스탭에서 선택한 브랜드 정보
    esBrandNumStep3: null, // 내 가구 견적 3번째 팝업에서 브랜드 개수
    esInfoStep4: {}, // 내 가구 견적 4번째에서 선택된 카테고리 필터 정보 저장
    esMyApplyProdList: [],
    esMyApplyTotalPrice: 0,
    esMyApplyTotalCnt: 0,
}

const esMyReducer = handleActions(
    {
        [ES_ESMY_INIT]: (state, { payload }) => {

            return ({
                ...state,
                error: null,
                esMyBrandCate1Step:[],
                esBrandMyStep1: null,
                esMyBudget: 0, 
                esCate2Name: null,
                esMyBrandCate3Step:[],
                esBrandMyStep3: null,
                esSelBrandStep3: [],
                esBrandNumStep3: null,
                esInfoStep4: {},
                esMyApplyProdList: [],
                esMyApplyTotalPrice: 0,
                esMyApplyTotalCnt: 0,
            })
        },
        [ES_ESMY_BRAND_CATE_STEP1]: (state, { payload : esMyBrandCate1Step}) => {

            return ({
                ...state,
                esMyBrandCate1Step:esMyBrandCate1Step,
            })
        },
        [ES_ESMY_BRAND_CATE_STEP3]: (state, { payload : esMyBrandCate3Step}) => {

            return ({
                ...state,
                esMyBrandCate3Step:esMyBrandCate3Step,
            })
        },
        [REQ_TYPE_POST_ESMY_STEP1_SUCCESS]: (state, { payload }) => {
            //console.log("REQ_TYPE_POST_ESMY_STEP1_SUCCESS = " + JSON.stringify(payload))

            return ({
                ...state,
                error: null,
                esBrandMyStep1: payload
            })
        },
        [REQ_TYPE_POST_ESMY_STEP1_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [ES_ESMY_BUDGET]: (state, { payload : esMyBudget}) => {

            return ({
                ...state,
                esMyBudget: esMyBudget,
            })
        },
        [REQ_TYPE_POST_ESMY_CATE2_NAME_SUCCESS]: (state, { payload }) => {
            //console.log("REQ_TYPE_POST_ESMY_CATE2_NAME_SUCCESS = " + JSON.stringify(payload))

            return ({
                ...state,
                error: null,
                esCate2Name: payload
            })
        },
        [REQ_TYPE_POST_ESMY_CATE2_NAME_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_POST_ESMY_STEP3_SUCCESS]: (state, { payload }) => {
            //console.log("REQ_TYPE_POST_ESMY_STEP1_SUCCESS = " + JSON.stringify(payload))
            
            return ({
                ...state,
                error: null,
                esBrandMyStep3: payload,
            })
        },
        [REQ_TYPE_POST_ESMY_STEP3_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [REQ_TYPE_POST_ESMY_STEP3_ADD_SUCCESS]: (state, { payload }) => {
            //console.log("REQ_TYPE_POST_ESMY_STEP1_SUCCESS = " + JSON.stringify(payload))
            let dataList = state.esBrandMyStep3.concat(payload);
            return ({
                ...state,
                error: null,
                esBrandMyStep3: dataList
            })
        },
        [REQ_TYPE_POST_ESMY_STEP3_ADD_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [ES_ESMY_SEL_BRAND_STEP3]: (state, { payload : esSelBrandStep3}) => {

            return ({
                ...state,
                esSelBrandStep3: esSelBrandStep3,
            })
        },
        [ES_ESMY_INFO_STEP4]: (state, { payload : esInfoStep4}) => {

            return ({
                ...state,
                esInfoStep4: esInfoStep4,
            })
        },
        [REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                error: null,
                esBrandNumStep3: payload,
            })
        },
        [REQ_TYPE_POST_ESMY_STEP3_BRAND_NUM_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [ES_ESMY_APPLY_PROD]: (state, { payload: addItem }) => {
            let esMyApplyProdList = state.esMyApplyProdList;

            //console.log("ES_ESMY_APPLY_PROD = " + JSON.stringify(state))

            addItem.map((curitem) => {
                if(esMyApplyProdList === undefined) {
                    state.esMyApplyProdList = [];
                    state.esMyApplyProdList.push(curitem);
                    esMyApplyProdList = state.esMyApplyProdList;
                    return null;
                }
                // 추가할 아이템이 이미 추가 되어 있는지 확인
                let objIdx = esMyApplyProdList.findIndex(obj => {
                    return (obj.prdct_id === curitem.prdct_id && obj.opt_id === curitem.opt_id);
                });

                // console.log(objIdx + " : " + JSON.stringify(addItem));

                // 신규 추가 의 경우 
                if (objIdx === -1) {
                    state.esMyApplyProdList.push(curitem);
                } else {
                    // 갯수 증가 시키고 전체 금액 계산 
                    let qty = ++state.esMyApplyProdList[objIdx].qty;
                    let price = state.esMyApplyProdList[objIdx].es_opt_pirce;
                    state.esMyApplyProdList[objIdx].es_prdct_price = (price * qty);
                }

                return null;
            })

            // 전체 갯수 구하기 
            state.esMyApplyTotalCnt = esMyApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.qty * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);

            // 전체 금액 구하기 
            state.esMyApplyTotalPrice = esMyApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.es_prdct_price * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);


            return ({ ...state });
        },
        [ES_ESMY_APPLY_PROD_DEL]: (state, { payload: prodinfo }) => {

            // 삭제 
            remove(state.esMyApplyProdList, (curitem) => {
                return (curitem.prdct_id === prodinfo.prdct_id && curitem.opt_id === prodinfo.opt_id);
            })

            // 전체 갯수 구하기 
            state.esMyApplyTotalCnt = state.esMyApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.qty * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);

            // 전체 금액 구하기 
            state.esMyApplyTotalPrice = state.esMyApplyProdList.reduce((resobj, curobj, idx) => {
                resobj = (resobj * 1) + (curobj.es_prdct_price * 1);
                // console.log("resobj : " + resobj);
                return resobj;
            }, []);


            return ({ ...state });
        },
    }
    , initialState);

export default esMyReducer;
